import { z } from "zod";
import { catalogueFieldErrorSchema } from "./catalogue-management.js";
import { passportCatalogueSchema, passportStableIdSchema } from "./passport-catalogue.js";

export const passportCatalogueVersionSchema = z
  .object({
    id: z.string().min(1),
    versionNumber: z.number().int().positive(),
    status: z.enum(["draft", "published", "retired"]),
    revision: z.number().int().positive(),
    createdAt: z.string().datetime(),
    createdBy: z.string().min(1),
    publishedAt: z.string().datetime().nullable(),
  })
  .strict();

export const passportCatalogueDraftSchema = z
  .object({ version: passportCatalogueVersionSchema, catalogue: passportCatalogueSchema })
  .strict();
export const passportCatalogueOverviewSchema = z
  .object({
    published: passportCatalogueVersionSchema,
    draft: passportCatalogueVersionSchema.nullable(),
    history: z.array(passportCatalogueVersionSchema),
  })
  .strict();
export const replacePassportCatalogueDraftSchema = z
  .object({ expectedRevision: z.number().int().positive(), catalogue: passportCatalogueSchema })
  .strict();
export const passportCatalogueRevisionSchema = z
  .object({ expectedRevision: z.number().int().positive() })
  .strict();
export const passportCatalogueValidationSchema = z
  .object({
    valid: z.boolean(),
    errors: z.array(catalogueFieldErrorSchema),
    warnings: z.array(catalogueFieldErrorSchema),
  })
  .strict();

const passportEntityImpactSchema = z
  .object({
    added: z.array(passportStableIdSchema),
    changed: z.array(passportStableIdSchema),
    archived: z.array(passportStableIdSchema),
  })
  .strict();
export const passportCatalogueImpactSchema = z
  .object({
    pages: passportEntityImpactSchema,
    stamps: passportEntityImpactSchema,
    criteria: passportEntityImpactSchema,
    resources: passportEntityImpactSchema,
    assessments: passportEntityImpactSchema,
    relations: passportEntityImpactSchema,
    remappedApplicability: z.array(z.string().min(1)),
    affectedEmployees: z.number().int().nonnegative(),
    pendingChecklistItems: z.number().int().nonnegative(),
  })
  .strict();
export const passportCataloguePublicationResultSchema = z
  .object({
    version: passportCatalogueVersionSchema,
    initializedProgress: z.number().int().nonnegative(),
  })
  .strict();

export type PassportCatalogueVersion = z.infer<typeof passportCatalogueVersionSchema>;
export type PassportCatalogueDraft = z.infer<typeof passportCatalogueDraftSchema>;
export type PassportCatalogueValidation = z.infer<typeof passportCatalogueValidationSchema>;
export type PassportCatalogueImpact = z.infer<typeof passportCatalogueImpactSchema>;
